import React, { Fragment, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import Recaptcha from "react-recaptcha";
import i18n from "../../../i18n";
import Configuration from "../../../config";

export default function Recapt(props) {
  const [field, meta, helper] = useField(props);
  const { setFieldValue } = useFormikContext();
  const { setValue } = helper;
  const key =
    Configuration.get("REACT_APP_RECAPTCHA_KEY") ||
    "6Lcx7QkaAAAAAOZhGUqBpK8mMRFOZysGG8ZWyQWs";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  const onVerifiedCallback = (response) => {
    setValue(response);
  };
  const reset = () => {
    setFieldValue(field.name, "");
  };
  const currentLanguage = i18n.language === "it-IT" ? "it-IT" : "en-US";

  return (
    <Form.Group
      type={field.type}
      className={meta.touched && meta.error ? "has-error" : ""}
    >
      <Fragment>
        <Recaptcha
          sitekey={key}
          render="explicit"
          theme="light"
          id={field.name}
          hl={currentLanguage}
          verifyCallback={onVerifiedCallback}
          onloadCallback={() => {
            console.log("done loading!");
          }}
          required={true}
          aria-describedby={
            meta.touched && meta.error ? field.name + "-error" : null
          }
          expiredCallback={reset}
        />
        {meta.touched && meta.error && (
          <p
            className="form-error-text paragraph-small-form"
            role="alert"
            id={field.name + "-error"}
          >
            {meta.error}
          </p>
        )}
      </Fragment>
    </Form.Group>
  );
}
